import { call, put, takeEvery } from "redux-saga/effects";
import * as actionTypes from "Redux/Actions/actionTypes";
import AddLoanIncome from "Communication/ApiClasses/AddLoanIncomeRequest";
import {
  doLoadingStart,
  doLoadingFinish,
} from "Components/Common/ProgressIndicator/Actions/ProgressIndicatorActions";
import STRINGS from "Constants/Strings";

// worker
function* handleAddLoanIncome(action) {
  yield put(doLoadingStart(STRINGS.INCOME.API_KEYS.LOAN_ADD_INCOME));
  console.log(action);
  const addLoanIncome = new AddLoanIncome(
    action.data.applicantId,
    action.data.finAnalysisId,
    action.data.payLoad
  );
  try {
    const result = yield call(addLoanIncome.getData);
    yield put({
      type: actionTypes.LOAN_ADD_INCOME_SUCCESS,
      response: result,
    });
    yield call(action.callback, result);
  } catch (e) {
    yield put({
      type: actionTypes.LOAN_ADD_INCOME_ERROR,
      error: e.message,
    });
  } finally {
    yield put(doLoadingFinish(STRINGS.INCOME.API_KEYS.LOAN_ADD_INCOME));
  }
}

// watcher
function* addLoanIncomeWatcherSaga() {
  yield takeEvery(actionTypes.LOAN_ADD_INCOME, handleAddLoanIncome);
}

export default addLoanIncomeWatcherSaga;
